/**
 * Angular imports.
 */
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports.
 */
import { ProductGetSampleModule } from './../../common/product-get-sample/product-get-sample.module';
import { ConfirmModalModule } from './../../common/confirm-modal/confirm-modal.module';
import { ProductLikeModule } from '../../common/product-like/product-like.module';
import { MediaModalModule } from '../../common/media-modal/media-modal.module';
import { ProductCommentBoxModule } from './../../common/product-comment-box/product-comment-box.module';
import { ProductCommentModule } from './../../common/product-comment/product-comment.module';
import { ContentCardModule } from '../../common/content-card/content-card.module';
import { PipesModule } from './../../pipes/pipes.module';
import { ProductMaskingCardModule } from '../../common/product-masking-card/product-masking-card.module';
import { ChannelUserCardModule } from '../../web-channel/channel-user-card/channel-user-card.module';
import { ConnectionCardModule } from '../../connection/connection-card/connection-card.module';
import { TaggedUsesModule } from './../../common/tagged-users/tagged-users.module';
import { DirectivesModule } from '../../directives/directives.module';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsEventModule } from '../../analytics-event/analytics-event.module';
import { WebinarCardModule } from '../../webinar/webinar-list/webinar-section/webinar-card/webinar-card.module';
import { WalkthroughModule } from '../../walkthrough/walkthrough.module';
import { WebDoctalkCardModule } from '../../web-doctalk/web-doctalk-list/web-doctalk-section/web-doctalk-card/web-doctalk-card.module';
import { ClinicalResourceCardModule } from '../../clinical-resource/clinical-resource-card/clinical-resource-card.module';

/**
 * Component imports.
 */
import { FeedCardComponent } from './feed-card.component';
import { ProductFollowComponent } from '../../common/product-follow/product-follow.component';



@NgModule({
  declarations: [
    FeedCardComponent,
    ProductFollowComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    PipesModule,
    ConnectionCardModule,
    ChannelUserCardModule,
    ProductMaskingCardModule,
    ContentCardModule,
    ProductCommentModule,
    ProductCommentBoxModule,
    MediaModalModule,
    ProductLikeModule,
    ConfirmModalModule,
    TaggedUsesModule,
    ProductGetSampleModule,
    NgbModalModule,
    NgbModule,
    AnalyticsEventModule,
    WebinarCardModule,
    WalkthroughModule,
    WebDoctalkCardModule,
    ClinicalResourceCardModule
  ],
  exports: [
    FeedCardComponent
  ]
})
export class FeedCardModule { }
